import type { FC, ReactNode } from 'react';

import { KnockProvider as KnockProviderBase } from '@knocklabs/react';
import { useFeatureFlagEnabled } from 'posthog-js/react';

import { NotificationFeedProvider } from 'features/notifications/lib/NotificationFeedContext';
import { NotificationToastListener } from 'features/notifications/ui/NotificationToastListener';
import { useAuth } from 'shared/lib/auth/useAuth';
import { FeatureFlag } from 'shared/lib/features/common';

type KnockProviderProps = {
  children: ReactNode;
};

const KNOCK_API_KEY = import.meta.env.VITE_APP_KNOCK_PUBLIC_API_KEY as string;

export const KnockProvider: FC<KnockProviderProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const userId = user?.profile?.email;
  const isKnockNotificationsEnabled = useFeatureFlagEnabled(FeatureFlag.KNOCK_NOTIFICATIONS);

  if (!(isAuthenticated && userId && KNOCK_API_KEY)) {
    return <>{children}</>;
  }

  return (
    <KnockProviderBase apiKey={KNOCK_API_KEY} userId={userId}>
      {isKnockNotificationsEnabled ? (
        <NotificationFeedProvider>
          {children}
          <NotificationToastListener />
        </NotificationFeedProvider>
      ) : (
        children
      )}
    </KnockProviderBase>
  );
};
